import { IStudentRow } from 'types';
import { getAllTags, sortWIthIntakeFirst } from './getAllTags';

export const getTags = (student: IStudentRow, isPathway: boolean) => {
  const allTags = getAllTags({
    tags: student.tags,
    isPathway,
  });

  const sortedWithIntake = sortWIthIntakeFirst(allTags);

  return sortedWithIntake
    .map(studentTag => {
      if (studentTag.pathwayUni) {
        return `${studentTag.label}: ${studentTag.pathwayUni}`;
      }
      return studentTag.label;
    })
    .join('; ');
};
